import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { DepositoBancoForm } from "./form";
const DepositoBancoFormRx = componentToRx(DepositoBancoForm);
type Entity = models.DepositoBancoDTO;
const resource = resources.DepositoBanco;

interface Props {
    match: match<{ id: string }>
}
interface State {
    value: Promise<Entity> | Entity;
}
class DepositoBancoEditComp extends React.PureComponent<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { value: this.getValue() };
    }
    get id(): number | "new" {
        const id = this.props.match.params.id;
        return id == "new" ? id : Number.parseInt(id);
    }
    async getValue() {
        if (this.id == "new") {
            return {} as Entity;
        } else {
            return await resource.Get(this.id);
        }
    }

    onChange = (value: Entity) => new Promise<void>(resolve => this.setState({ value: value }, resolve));
    onGuardar = async () => {
        if (await kea.yesno("¿Contabilizar deposito de banco?", "Se va a crear una poliza contable a partir de este deposito de banco")) {
            const id = this.id;
            const func = resource.ContabilizarDeposito;
            const value = await this.state.value;
            await func(value);
            history.go("../");
        }
    }

    onGuardarSinContabilizar = async () => {
        if (await kea.yesno("¿Guardar deposito de banco sin contabilizar?", "Se guardarán los cambios realizados a este deposito de banco sin contabilizarlo")) {
            const id = this.id;
            const func = resource.Update;
            const value = await this.state.value;
            await func(value);
            history.go("../");
        }
    }

    render() {
        const props = this.props;
        const params = props.match!.params.id;
        return <DepositoBancoFormRx
            value={this.state.value}
            onChange={this.onChange}
            onGuardarSinContabilizar={this.onGuardarSinContabilizar}
            nuevo={this.id == "new"}
            onGuardar={this.onGuardar} />;
    }
}

export const DepositoBancoEdit = withRouter(DepositoBancoEditComp);


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/depositobanco/edit/edit.tsx